import { createStorageUtils, openPDF } from '@avanta/shared/utils/storage';
import { STORAGE_PREFIX } from 'constants/storage';

export const { getUserId, getRefreshToken, getAnonymousTokenCookie, setCookieWithoutExpiry } =
  createStorageUtils(STORAGE_PREFIX);

export { openPDF };

export const getFromSessionStorage = <T>(key: string): T | null => {
  try {
    const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${key}`);
    if (!raw) return null;
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
};

export const setInSessionStorage = (key: string, value: unknown): void => {
  sessionStorage.setItem(`${STORAGE_PREFIX}${key}`, JSON.stringify(value));
};
